export default [
	{//会员升级审批
		path: 'member_upgrade_list',
		name: 'm_member_upgrade',
		component: () => import('@/pages/member/member_upgrade_list')
	},
	{//会员管理
		path: 'member_list',
		name: 'm_platform_user',
		component: () => import('@/pages/member/platform_user_list')
	}, {//会员详情
		path: 'member_detail/:platform_user_id',
		name: 'member_detail',
		meta: {
			title: '会员详情'
		},
		props: route => route.params,
		component: () => import('@/pages/member/platform_user_detail')
	}, {//会员审批
		path: 'member_apply_list',
		name: 'm_platform_user_apply',
		props: route => route.query,
		component: () => import('@/pages/member/platform_user_apply_list')
	}, {  // 代理等级列表
		path: 'user_level_list',
		name: 'm_user_level',
		component: () => import('@/pages/member/user_level_list')
	}, {  // 代理等级编辑
		path: 'user_level_edit/:id',
		name: 'level_edit',
		meta: {
			title: '编辑代理等级'
		},
		props: route => route.params,
		component: () => import('@/pages/member/user_level_edit')
	}, {  // 代理等级新增
		path: 'user_level_add',
		name: 'level_add',
		meta: {
			title: '新增代理等级'
		},
		component: () => import('@/pages/member/user_level_edit')
	}, {  // 价格管控
		path: 'special_price_list',
		name: 'm_special_price',
		props: route => route.query,
		component: () => import('@/pages/member/special_price_list')
	}, {  // 价格管控新增页
		path: 'special_price_add',
		name: 'special_price_add',
		meta: {
			title: '申请特殊价格'
		},
		props: route => route.query,
		component: () => import('@/pages/member/special_price_add')
	}, {  // 价格管控编辑页
		path: 'special_price_edit/:id',
		name: 'special_price_edit',
		meta: {
			title: '编辑特殊价格申请'
		},
		props: route => route.params,
		component: () => import('@/pages/member/special_price_edit')
	},  {  // 价格管控详情
		path: 'special_price_detail/:id',
		name: 'special_price_detail',
		meta: {
			title: '价格管控详情'
		},
		props: route => route.params,
		component: () => import('@/pages/member/special_price_detail')
	},  {  // 价格管控审核
		path: 'special_price_verify/:id',
		name: 'special_price_verify',
		meta: {
			title: '价格管控审核'
		},
		props: route => route.params,
		component: () => import('@/pages/member/special_price_verify')
	}, {  // 认证列表
		path: 'user_auth_list',
		name: 'm_user_auth',
		props: route => route.query,
		component: () => import('@/pages/member/user_auth_list')
	},  {  // 认证详情
		path: 'user_auth_detail/:id',
		name: 'user_auth_detail',
		meta: {
			title: '代理认证详情'
		},
		props: route => route.params,
		component: () => import('@/pages/member/user_auth_detail')
	},  {  // 认证审核
		path: 'user_auth_verify/:id',
		name: 'user_auth_verify',
		meta: {
			title: '代理认证审核'
		},
		props: route => route.params,
		component: () => import('@/pages/member/user_auth_verify')
	},  {  // 会员配置
		path: 'member_config',
		name: 'm_member_config',
		component: () => import('@/pages/member/member_config')
	},
	{  // 代理管理
		path: 'member_user_list',
		name: 'm_member_user',
		component: () => import('@/pages/member/member_user_list')
	}, {  // 代理礼包
		path: 'gift_package_list',
		name: 'm_gift_package_info',
		component: () => import('@/pages/member/gift_package_list')
	}, {  // 代理礼包新增页
		path: 'gift_package_add',
		name: 'gift_package_add',
		meta: {
			title: '新增代理礼包'
		},
		props: route => route.query,
		component: () => import('@/pages/member/gift_package_add')
	}, {  // 代理礼包编辑页
		path: 'gift_package_edit/:id',
		name: 'gift_package_edit',
		meta: {
			title: '编辑代理礼包'
		},
		props: route => route.params,
		component: () => import('@/pages/member/gift_package_edit')
	}, {  // 代理礼包详情页
		path: 'gift_package_detail/:id',
		name: 'gift_package_detail',
		meta: {
			title: '代理礼包详情'
		},
		props: route => route.params,
		component: () => import('@/pages/member/gift_package_detail')
	}, {  // 分销设置
		path: 'distribution_config',
		name: 'm_share',
		props: route => route.params,
		component: () => import('@/pages/member/distribution_config')
	}, {  // 代理权益列表
		path: 'growth_level_list',
		name: 'm_user_growth',
		component: () => import('@/pages/member/growth_level_list')
	}, {  // 代理权益编辑
		path: 'growth_level_edit/:id',
		name: 'edit_user_growth',
		meta: {
			title: '编辑成长等级权益'
		},
		props: route => route.params,
		component: () => import('@/pages/member/growth_level_edit')
	}, {  // 云仓库存
		path: 'cloud_stock',
		name: 'm_cloud_stock',
		component: () => import('@/pages/member/cloud_stock_list')
	}, {  // 云仓库存台账
		path: 'cloud_stock_log',
		name: 'm_cloud_stock_log',
		component: () => import('@/pages/member/cloud_stock_log_list')
	}, {  // 成长任务管理
		path: 'growth_rule_config',
		name: 'm_growth_regulation',
		component: () => import('@/pages/marketing/growth_rule_config')
	}, {  // 成长值收支明细
		path: 'growth_record',
		name: 'm_growth_record',
		component: () => import('@/pages/marketing/growth_record')
	}, {  //业绩明细列表
		path: 'performance_record',
		name: 'm_member_performance_record',
		component: () => import('@/pages/member/performance_record_list')
	}, {  // 区域配置
		path: 'region',
		name: 'm_region',
		props: route => route.params,
		component: () => import('@/pages/member/region_list')
	}
];